export const VISIBLE_TYPE = {
  ADMIN_HIDDEN: 0, // 어드민 숨김
  NORMAL: 1, // 정상
  USER_HIDDEN: 2, // 유저 숨김
  BLOCK: 3, // 차단
};
